export default {"src":"/_next/static/image/public/images/ic_store.4e8d578b20701fcb44e8cfc5415903c6.svg","height":32,"width":32};